import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../Assets/Icon/CustomIcon';
import usePhoneCall from '../../../Hooks/useCallHandler';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import EmTelContactCard from '../ui/EmTelContactCard';
import { filterEmTelList, groupContactsByChosung } from '../ui/emTelUtils';

export default function M_EMT_BASIC(props) {
  const { emTelList = [] } = props;
  const [search, setSearch] = useState('');
  const { handleCall } = usePhoneCall();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const isHeadManager =
    userInfo?.authCd === 'HEAD_MANAGER' ||
    userInfo?.authCd === 'BUSINESS_OWNER';

  const filtered = useMemo(
    () => filterEmTelList(emTelList, { search }),
    [emTelList, search]
  );

  const groupedContacts = useMemo(
    () => groupContactsByChosung(filtered),
    [filtered]
  );

  return (
    <div className="flex h-full min-h-0 flex-col bg-[#f8faf9] text-[#1b1c1c]">
      <main className="mx-auto w-full max-w-2xl flex-1 space-y-6 overflow-y-auto overscroll-contain px-5 pt-6 pb-[calc(1.5rem+4rem+env(safe-area-inset-bottom,0px))]">
        <div className="relative">
          <div className="relative flex items-center rounded-2xl border border-[#dee2e6]/80 bg-white px-5 py-3.5 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_4px_6px_-2px_rgba(0,0,0,0.05)] transition-all focus-within:border-[#34a853] focus-within:ring-4 focus-within:ring-[#34a853]/10">
            <span className="mr-3 text-[#34a853]">
              <Icon.Search width="22" height="22" />
            </span>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={
                userInfo?.internalYn === '1'
                  ? '사업장 관리자 연락처 검색...'
                  : '부서 내 연락처 검색...'
              }
              className="w-full border-none bg-transparent text-sm text-[#1b1c1c] outline-none placeholder:text-[#5f6368]/50"
            />
          </div>
        </div>

        <div className="space-y-4">
          <div className="mb-2 flex items-center justify-between gap-3">
            <h2 className="text-sm font-semibold tracking-wide text-[#5f6368] uppercase">
              비상연락망 목록({filtered.length})
            </h2>
            {isHeadManager && (
              <button
                type="button"
                onClick={() => navigate('/M_EmergencyTel/write')}
                className="inline-flex shrink-0 items-center gap-1 rounded-full border border-[#34a853]/20 bg-[#e9f5eb] px-3 py-1.5 text-xs font-semibold text-[#34a853] transition-colors hover:bg-[#34a853] hover:text-white"
              >
                <Icon.Setting width="14" height="14" />
                설정
              </button>
            )}
          </div>

          {groupedContacts.length > 0 ? (
            <div className="space-y-6">
              {groupedContacts.map(([groupLabel, items]) => (
                <div key={groupLabel} className="space-y-3">
                  <h3 className="px-1 text-sm font-semibold text-[#34a853]">
                    {groupLabel}
                  </h3>
                  {items.map((item) => (
                    <EmTelContactCard
                      key={item._key}
                      item={item}
                      onCall={handleCall}
                    />
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <div className="rounded-2xl border border-[#dee2e6]/30 bg-white px-4 py-12 text-center shadow-sm">
              <p className="text-base font-bold text-[#1b1c1c]">
                등록된 비상연락처가 없습니다.
              </p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
